import { useCallback } from 'react';
import { createDefaultHudPanelStates, type HudPanelId, type HudPanelStates } from '@sorrem/shared';
import { useAccountSetting } from './use-account-setting';

const DEFAULT_HUD_PANELS: Readonly<HudPanelStates> = createDefaultHudPanelStates();

interface HudPanelsState {
    /** Which run HUD panels are open; the defaults until settings load. */
    panels: Readonly<HudPanelStates>;
    /** Opens or closes a panel and saves it to the account settings (applied optimistically). */
    setPanelOpen: (panel: HudPanelId, open: boolean) => void;
}

/**
 * Whether the run HUD's inventory, map and commission panels are open. An
 * account setting, so a panel stays the way the player left it from one run
 * (and browser) to the next.
 */
export function useHudPanels(): HudPanelsState {
    const { value: panels, set } = useAccountSetting('hudPanels', DEFAULT_HUD_PANELS);

    const setPanelOpen = useCallback((panel: HudPanelId, open: boolean): void => {
        set((current) => (current[panel] === open ? current : { ...current, [panel]: open }));
    }, [set]);

    return { panels, setPanelOpen };
}
